import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast, ToastContainer } from "react-toastify";

// import { allBooksCategories } from "../../../../data/CategoriesData"
import { editBooksform, deleteBooksform } from "../../../../hooks/apiAxios"

import SuccessErrorMsg from "../../../../utilities/SuccessErrorMsg"
import { handleBookImageChange } from "../../../../utilities/handleFunctions/HandelImageChange"
import { RiyalImgBLK } from '../../../../components/common/RiyalImg';

import ReactQuill from 'react-quill-new';
import 'react-quill/dist/quill.snow.css';
import { useAdminLibCategory } from '../../../../context/Admins/AdminLibCategoryContext';



export function BookDataModify({ id, title, img, imgAlt, price, description, qty, available, author, pubYear, bookCategory, bookCategoryId, pages, BookSampleImg }) {
    const [image, setImage] = useState(img);
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    // const [dataUpdate, setDataUpdate] = useState(false);
    const [loading, setLoading] = useState(false);
    const { allCategories } = useAdminLibCategory();

    const thisYear = new Date().getFullYear();

    // //React Quill modules and formats
    // const modules = {
    //     toolbar: [
    //         [{ 'header': [1, 2, 3, false] }],
    //         ['bold', 'italic', 'underline', 'strike'],
    //         [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    //         ['clean'],
    //         ['rtl']
    //     ]
    // };

    async function onSubmit(formData) {
        setLoading(true);

        try {
            // //added to sanitize description input
            // const sanitizedData = {
            //     ...formData,
            //     description: formData.description.replace(/[\u200B-\u200D\uFEFF]/g, '') // Remove zero-width spaces
            // };

            const response = await editBooksform(id, formData);

            if (response.data.isSuccess) {
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
                toast.success("تم تعديل البيانات ..");

            } else {
                toast.warn("حدث خطأ ما، حاول مرة أخرى");
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            toast.error("حدث خطأ ما، تواصل مع الدعم");
        } finally {
            setLoading(false);
        }
    }

    async function deleteBookBtn(id) {
        setLoading(true);
        try {
            const response = await deleteBooksform(id);
            if (response.data.isSuccess) {
                // setDataUpdate(true);
                toast.success("تم تعديل البيانات ..");
                setTimeout(() => {
                    window.location.reload();
                }, 3000);

            } else {
                toast.error("حدث خطأ ما، حاول مرة أخرى");
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            switch (error.response.status) {
                case 413:
                    toast.warn("حجم الصورة كبير");
                    break;
                case 400:
                    toast.warn("تأكد من إدخال جميع البيانات بالشكل الصحيح");
                    break;
                default:
                    toast.warn("حدث خطأ ما، تواصل مع الدعم");
            }

        } finally {
            setLoading(false);

        }
    }

    return (
        <div id={`book-edit${id}`}
            className="modal fade bg-transparent"
            tabIndex="-1"
            aria-hidden="true"
            aria-labelledby="bookEditForm"
            data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "800px" }}>
                <div className="modal-content">
                    <div className="modal-header" id="bookEditForm">
                        <h5 className="modal-title">تعديل كتاب رقم {id}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body p-0">
                        <form
                            encType="multipart/form-data"
                            //  method="patch"
                            className='d-flex flex-column flex-md-row mx-auto text-start px-3 pb-4 align-items-center'
                            onSubmit={handleSubmit(onSubmit)}>

                            <div className="book-image-container position-relative m-auto mt-3 my-md-auto ms-md-2">
                                <img className="book-image mx-auto"
                                    crossOrigin="anonymous"
                                    src={image ? image : BookSampleImg} alt={imgAlt}

                                />
                                <h6 className="profile-change-text border text-center">تغيير الصورة</h6>

                                <input
                                    className="opacity-0 profile-image-input"
                                    type="file"
                                    accept="image/jpeg"
                                    onChange={(e) => handleBookImageChange(e, setValue, setImage)}
                                />
                            </div>

                            <div className="d-flex flex-column col-11 col-md ms-4 mb-5 my-md-5 gap-2">
                                {/* Input fields */}
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">الكتاب</span>
                                    <input
                                        className={`form-control ${errors.title && "border border-danger"}`}
                                        type="text"
                                        defaultValue={title}
                                        // onChange={(e) => { setValue("title", e.target.value) }}
                                        {...register("title", { required: true, minLength: 4 })}
                                    />
                                    {errors.title && <p className='errors-msg'>الاسم مطلوب أكبر من 4 أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >المؤلف</span>
                                    <input
                                        className='form-control'
                                        type="text"
                                        defaultValue={author}
                                        {...register("author", { required: true, minLength: 4 })} />
                                    {errors.author && <p className='errors-msg'>أدخل المؤلف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >السعر</span>
                                    <input
                                        className='form-control text-start'
                                        type="number"
                                        defaultValue={price}
                                        {...register("price", { required: true, valueAsNumber: true })} />
                                    <span className="input-group-text" ><RiyalImgBLK /></span>
                                    {errors.price && <p className='errors-msg'> أدخل السعر الصحيح</p>}
                                    <span className="input-group-text" >الكمية</span>
                                    <input
                                        className='form-control text-start'
                                        type="number"
                                        defaultValue={qty}
                                        {...register("quantity", { valueAsNumber: true })} />
                                    {errors.qty && <p className='errors-msg'> أدخل الكمية</p>}
                                    <span className="input-group-text" >الصفحات</span>
                                    <input
                                        className='form-control text-start'
                                        type="number"
                                        defaultValue={pages}
                                        {...register("numberOfPages", { valueAsNumber: true })} />
                                    {errors.pages && <p className='errors-msg'> أدخل الصفحات</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >التصنيف</span>
                                    <select className='form-select text-start'
                                        defaultValue={bookCategoryId}
                                        {...register("categoryId", { valueAsNumber: true })}>
                                        <option value={bookCategoryId}>{bookCategory}</option>
                                        {allCategories
                                            .filter(category => category.id !== bookCategoryId)
                                            .map((category) => (
                                                <option key={category.id} value={category.id}>
                                                    {category.nameAr}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >متوفر</span>
                                    <select className='form-select text-start'
                                        {...register("available")}
                                        defaultValue={available}
                                    // onChange={e => setValue("available", e.target.value)}
                                    >
                                        <option value={true}>متوفر</option>
                                        <option value={false}>طباعة نسخة خاصة</option>
                                    </select>
                                    <span className="input-group-text" >تاريخ النشر</span>
                                    <input
                                        className={`form-control border`}
                                        type="number"
                                        defaultValue={pubYear}
                                        {...register("publishedDate", { required: true, pattern: /^\d{4}$/, min: 1980, max: { thisYear }, valueAsNumber: true })} />
                                    {errors.pubYear && <p className='errors-msg'> تاريخ النشر أكبر من ١٩٨٠م</p>}
                                </div>

                                <div className="input-group input-group-sm flex-column">
                                    <span className="input-group-text w-100">الوصف</span>
                                    <ReactQuill
                                        theme="snow"
                                        defaultValue={description}
                                        onChange={(content) => {
                                            setValue("description", content);
                                        }}
                                        modules={{
                                            toolbar: {
                                                container: [
                                                    [{ 'header': [1, 2, 3, false] }],
                                                    ['bold', 'italic', 'underline', 'strike'],
                                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                    [{ 'direction': 'rtl' }], ['link'], ['clean']
                                                ]
                                            }
                                        }}
                                        className={`${errors.description && "border border-danger"}`}
                                        style={{ height: '200px', marginBottom: '40px' }}
                                    />
                                    {errors.description && <p className='errors-msg'> مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                                {/* old text for description */}
                                {/* <div className="input-group input-group-sm">
                                    <span className="input-group-text">الوصف</span>
                                    <textarea
                                        className={`form-control ${errors.title && "border border-danger"}`}
                                        type="textArea"
                                        rows="10"
                                        onChange={(e) => { setValue("description", e.target.value) }}
                                        defaultValue={description}
                                        {...register("description", { required: true, minLength: 10 })} />
                                    {errors.description && <p className='errors-msg'> مطلوب أكبر من ١٠ أحرف</p>}
                                </div> */}


                                <p className='notice-font bg-warning p-1 rounded'>إذا كانت الكمية (صفر) سيتم اخفاء الكتاب للعرض</p>
                            </div>
                            <button
                                className='btn btn-dark-orange text-white col-2 me-3 mb-3 position-absolute bottom-0 end-0'
                                type="submit">
                                {loading &&
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"></span>
                                }
                                تعديل
                            </button>
                            <button
                                className='btn btn-light-beige text-white col-2 ms-3 mb-3 position-absolute bottom-0 start-0' onClick={() => deleteBookBtn(id)}>
                                {loading &&
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"></span>
                                }
                                حذف
                            </button>

                            {/* <input className='btn btn-dark-orange text-white col-2 me-3 mb-3 position-absolute bottom-0 end-0 ' type="submit" value="تعديل" /> */}


                        </form>
                        <SuccessErrorMsg
                            ToastContainer={ToastContainer}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}